<div class="td-wb-tabs-slider"
     [class.td-wb-tabs-slider--hidden]="!isScrollable()">
  <div class="td-wb-tabs-slider__button-container td-wb-tabs-slider__button-container--left"
       [class.td-wb-tabs-slider__button-container--left--no-scroll]="!showPrevButton()">
    <button class="td-wb-tabs-slider__button"
            tdWbIconButton
            tdWbIconButtonShape="square"
            tdWbIconButtonBackground="grey"
            [attr.aria-label]="'tdWb.pagination.PREVIOUS' | translate"
            [disabled]="!showPrevButton()"
            (click)="previous()">
      <td-wb-icon size="8x16"
                  iconId="arrow-left" />
    </button>
  </div>
  <!-- Slider Controls -->
  <div tdWbScrollable
       class="td-wb-tabs-slider__container"
       [tabbable]="false">
    <ng-content />
  </div>
  <div class="td-wb-tabs-slider__button-container td-wb-tabs-slider__button-container--right"
       [class.td-wb-tabs-slider__button-container--right--no-scroll]="!showNextButton()">
    <button class="td-wb-tabs-slider__button"
            tdWbIconButton
            tdWbIconButtonShape="square"
            tdWbIconButtonBackground="grey"
            [attr.aria-label]="'tdWb.pagination.NEXT' | translate"
            [disabled]="!showNextButton()"
            (click)="next()">
      <td-wb-icon size="8x16"
                  iconId="arrow-right" />
    </button>
  </div>
</div>
